import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeConfigContainerVisibility } from '@store/errorLogicConfig/configContainer/actions';
import { setMode } from '@store/errorLogicConfig/base/actions';
import { configTableSelector } from '@store/errorLogicConfig/base/selectors';
import ConfigContainer from '../ConfigContainer';
import {
  Header, HeaderWrapper, ButtonWrapper,
} from '../styled';
import { getMode, getButtonText, getHeaderText } from './utils';
import { Button, Space } from 'antd';

const Summary = () => {
  const dispatch = useDispatch();
  const mode = useSelector(configTableSelector);
  const buttonText = getButtonText(mode);
  const headerText = getHeaderText(mode);

  const onConfigLogSelector = () => {
    dispatch(setMode(getMode(mode)));
  };

  const newConfigContainer = () => {
    dispatch(changeConfigContainerVisibility(true));
  };

  return (
    <HeaderWrapper>
      <Header>
        {window.__POWERED_BY_QIANKUN__ ? '' : headerText}
      </Header>
      <ButtonWrapper>
        <Space>
          <Button key="config-logs" onClick={onConfigLogSelector}>
            {buttonText}
          </Button>
          <Button key="new-config" onClick={newConfigContainer}>
            New Config
          </Button>
        </Space>

        <ConfigContainer />
      </ButtonWrapper>
    </HeaderWrapper>
  );
};

export default Summary;
